import React, {useEffect, useState, useRef, useCallback} from 'react'
import {Trans, useTranslation} from "react-i18next";
import {ModalInfo} from "./modal.info";
import Api from "../../service/api";
import FormGen from "../form/formgen2";
import {useDispatch} from "react-redux";
import {UserAction} from "../../redux/reducers/user";
import {useAppSelector} from "../../redux/store";
import {useDashboard} from "../../service/api.swr";
import {IconUsdt, IconWallet} from "../icons";
import styled from "styled-components";
import {Currency, IconPlace, LinkContainer} from "./modal.topup";
import {CURRENCY_USDT_TRC20} from "../../constants";
import {AlertErrorSmall, AlertSuccessSmall} from "../alert";

const MODAL_WIDTH = '400px'

export const HintAmount = styled.div`
    display: flex;
    justify-content: space-between;
`

const WithdrawSuccessWrapper = styled.div`

`

export const ContentContainer = styled.div`
    display: flex;
    margin-bottom: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`

export const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`

export const DetailLabel = styled.p`
    color: var(--it-text-grey);
    /* Description */
    font-family: "Basis Grotesque Pro";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 12px */
    letter-spacing: 0.36px;
    text-transform: uppercase;

    &[data-red] {
        color: var(--it-text-red);
    }
    &[data-green] {
        color: var(--it-text-green);
    }
`

export const DetailValue = styled.p`
    color: var(--it-text-white);
    /* H4 */
    font-family: "Druk Wide";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
    text-transform: uppercase;

    &[data-red] {
        color: var(--it-text-red);
    }
    &[data-green] {
        color: var(--it-text-green);
    }
`

function WithdrawForm({reloadUserInfo, onWithdrawCreated}){
    const {t} = useTranslation();
    const formRef = useRef()
    const {user} = useAppSelector();
    const [formFields, setFormFields] = useState([]);

    useEffect(()=>{
        reloadUserInfo()
    }, [])

    useEffect(()=>{
        setFormFields([
            {
                name: 'currency',
                type: 'hidden',
                defaultValue: 'usdttrc20'
            },
            {
                label: t('form.field.wallet_address'),
                error: {
                    required: t('form.error.required', {name: t('form.field.wallet_address')}),
                },
                defaultValue: '',
                name: 'wallet',
                type: 'text',
                placeholder: t('form.field.placeholder', {name: t('form.field.wallet_address')}),
                hint: t(`form.field.wallet_address_hint_usdt`),
            },
            {
                label: t('form.field.amount'),
                error: {
                    required: t('form.error.required', {name: t('form.field.amount')}),
                    min: {
                        value: 10,
                        message: t('form.error.min', {value: 10, name: t('form.field.amount')}),
                    },
                    max: {
                        value: user.balance_for_withdraw,
                        message: t('form.error.max', {value: user.balance_for_withdraw, name: t('form.field.amount')}),
                    }
                },
                defaultValue: 0,
                name: 'amount',
                type: 'text',
                // placeholder: t('form.field.placeholder', {name: t('form.field.amount_topup_placeholder')}),
                hint: <HintAmount>
                    <div>Fee: 1% + 1$</div>
                    <div style={{display: "flex", gap: '8px'}}>
                        <div>Min: 10</div>
                        <div><span>Max:</span> ${user.balance_for_withdraw}</div>
                    </div>
                </HintAmount>,
            },
        ])
    }, [user.balance_for_withdraw])

    const onSubmit = (formData, setError, setAlerts) => {
        return Api.getCSRFCookie().then(() => Api.paymentWithdraw(formData.currency, formData.amount, formData.wallet));
    }

    return (
        <>
            <LinkContainer>
                <IconPlace>
                    <IconUsdt size={24} />
                </IconPlace>
                <Currency>{CURRENCY_USDT_TRC20}</Currency>
            </LinkContainer>

            <FormGen ref={formRef}
                     items={formFields}
                // initialValues={{}}
                     onSubmit={onSubmit}
                     onComplete={onWithdrawCreated}
                     submitText={t(`modal.withdraw.btn_save`)}
                     submitBtnStyles={{width: '100%'}}
            />
        </>
    )
}

function WithdrawFormAdmin({onWithdrawCreated}){
    const {t} = useTranslation();
    const formRef = useRef()
    const {user} = useAppSelector();
    const [formFields, setFormFields] = useState([]);

    useEffect(()=>{
        setFormFields([
            {
                name: 'currency',
                type: 'hidden',
                defaultValue: 'usdttrc20'
            },
            {
                label: t('form.field.wallet_address'),
                error: {
                    required: t('form.error.required', {name: t('form.field.wallet_address')}),
                },
                defaultValue: '',
                name: 'wallet',
                type: 'text',
                placeholder: t('form.field.placeholder', {name: t('form.field.wallet_address')}),
                hint: t(`form.field.wallet_address_hint_usdt`),
            },
            {
                label: t('form.field.amount'),
                error: {
                    required: t('form.error.required', {name: t('form.field.amount')}),
                },
                defaultValue: 0,
                name: 'amount',
                type: 'text',
                hint: <HintAmount>
                    <div>Fee: 1% + 1$</div>
                    <div style={{display: "flex", gap: '8px'}}>
                        <div>Min: 10</div>
                        <div><span>Max:</span> ${user.balance_for_withdraw}</div>
                    </div>
                </HintAmount>,
            },
            {
                label: t('form.field.reason'),
                error: {
                    required: t('form.error.required', {name: t('form.field.reason')}),
                },
                defaultValue: '',
                name: 'reason',
                type: 'text',
            },
        ])
    }, [])

    const onSubmit = (formData, setError, setAlerts) => {
        return Api.getCSRFCookie().then(() => Api.paymentWithdrawAdmin(formData.currency, formData.amount, formData.wallet, formData.reason));
    }

    return (
        <>
            <LinkContainer>
                <IconPlace>
                    <IconUsdt size={24} />
                </IconPlace>
                <Currency>{CURRENCY_USDT_TRC20}</Currency>
            </LinkContainer>

            <FormGen ref={formRef}
                     items={formFields}
                // initialValues={{}}
                     onSubmit={onSubmit}
                     onComplete={onWithdrawCreated}
                     submitText={t(`modal.withdraw.btn_save`)}
                     submitBtnStyles={{width: '100%'}}
            />
        </>
    )
}

function WithdrawSuccess({total, sent, fee, currency}){
    const {t} = useTranslation();
    currency = currency?.toUpperCase();
    return (
      <>
         <WithdrawSuccessWrapper>
             <AlertSuccessSmall title={t(`modal.withdraw.complete.description`)} />

             <ContentContainer style={{marginTop: '25px'}}>
                 <DetailContainer>
                     <DetailLabel>
                         {t(`modal.withdraw.complete.will_receive`)}
                     </DetailLabel>
                     <DetailValue>
                         {sent}{` `}{currency}
                     </DetailValue>
                 </DetailContainer>

                 <DetailContainer>
                     <DetailLabel>
                         {t(`modal.withdraw.complete.fee`)}
                     </DetailLabel>
                     <DetailValue>
                         {fee}{` `}{currency}
                     </DetailValue>
                 </DetailContainer>

                 <DetailContainer>
                     <DetailLabel>
                         {t(`modal.withdraw.complete.total`)}
                     </DetailLabel>
                     <DetailValue>
                         {total}{` `}{currency}
                     </DetailValue>
                 </DetailContainer>
             </ContentContainer>
         </WithdrawSuccessWrapper>
      </>
    )
}

function WithdrawMinAmountRequired({minWithdrawalAmount}){
    const {t} = useTranslation();
    return (
      <>
          <AlertErrorSmall title={t(`modal.withdraw.error.min_amount_required`, {minAmount: minWithdrawalAmount})}/>
      </>
    )
}

export const ModalWithdraw = ({
                                isAdmin = false,
                                 onConfirm,
                                 ...rest
                             }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const {user, settings} = useAppSelector();
    const {mutate: mutateDashboard} = useDashboard();
    const [withdraw, setWithdraw] = useState(false);

    const reloadUserInfo = useCallback(()=>{
        Api.getUserInfo()
            .then((userInfo) => Promise.all([
                dispatch(UserAction.loadUserInfoCompleted(userInfo))
            ]));
    }, [])

    const onWithdrawCreated = useCallback((result)=>{
        setWithdraw(result);
        mutateDashboard();
        reloadUserInfo();
    }, [reloadUserInfo, mutateDashboard])
    const canWithdraw = settings.min_withdraw_amount <= user.balance;

    /*const fakeWithdraw = {
        total: 100,
        sent: 89,
        fee: 11,
        currency: 'USDT'
    }*/

    useEffect(()=>{
        setWithdraw(false);
    }, [rest.isOpen])

    return (
        <ModalInfo
            isModal={true}
            width={MODAL_WIDTH}
            maxWidth={`max-w-xs sm:max-w-lg md:max-w-xl lg:max-w-2xl`}
            icon={<IconWallet size={20} />}
            title={t('modal.withdraw.title')}
            body={
                withdraw ? <WithdrawSuccess {...withdraw}  />
                    :   <>
                        {isAdmin ?
                            <WithdrawFormAdmin onWithdrawCreated={onWithdrawCreated} />
                            : (
                                canWithdraw
                                    ? <WithdrawForm onWithdrawCreated={onWithdrawCreated} reloadUserInfo={reloadUserInfo} />
                                    : <WithdrawMinAmountRequired minWithdrawalAmount={settings.min_withdraw_amount} />
                            )}
                        </>
            }
            {...rest}
        />
    )
}


